import { useAsyncData, showError } from '#imports';
import { useLayoutStore } from '~dsc/stores/cms/layout';

export const useLayoutLoad = async (key = 'site-layout') => {
    const { error } = await useAsyncData(key, () => useLayoutStore().layoutLoad());
    if (error.value) {
        throw showError(error.value);
    }
};
